module.exports = __webpack_public_path__ + "img/127.11ea5c6e.jpg";